<script setup>
import WelcomeItem from './WelcomeItem.vue'
import DocumentationIcon from './icons/IconDocumentation.vue'
// import ToolingIcon from './icons/IconTooling.vue'
// import EcosystemIcon from './icons/IconEcosystem.vue'
// import CommunityIcon from './icons/IconCommunity.vue'
// import SupportIcon from './icons/IconSupport.vue'
</script>

<template>
  <div class="container-fluid">
    <div class="row mt-2">
      <div class="col-md-3 col-sm-12">
        <div class="mb-3">
          <div class="form-group">
            <label for="integrated_number" class="col-form-label">Integrated Number </label>
            <select class="form-control" id="integrated_number" v-model="integrated_number"
                    @change="getOnLoadMessageLogs" required>
              <option v-for="(option, key) in phones" :value="option.phonenumberId" :key="key">{{ option.name }}
                (+91 {{ option.phonenumber }})
              </option>
            </select>
          </div>
          <div class="list-group">
            <WelcomeItem v-for="(option, key) in tables" :value="option._id" :key="key"
                         @click="getOnLoadMessageList(key)">
              <template #icon>
                <DocumentationIcon/>
              </template>
              <template #heading>{{ option._id }}</template>
              <template #count>{{ option.count }}</template>
              <template #timestamp>{{ format_date(option.timestamp) }}</template>
              {{ option.template }}
            </WelcomeItem>
          </div>
        </div>
      </div>

      <div class="col-md-9 col-sm-12">
        <div class="mb-3">
          <div class="card" id="chat2">
            <div class="card-header d-flex justify-content-between align-items-center p-3">
              <h5 class="mb-0">{{ titleNumber }}</h5>
              <button type="button" class="btn btn-info btn-sm" data-mdb-ripple-color="dark">Refresh</button>
            </div>
            <div class="card-body scollHw" data-mdb-perfect-scrollbar="true" style="position: relative; height: 400px">

              <!--              <div class="d-flex flex-row justify-content-start">-->
              <!--                <img src="https://mdbcdn.b-cdn.net/img/Photos/new-templates/bootstrap-chat/ava3-bg.webp"-->
              <!--                     alt="avatar 1" style="width: 45px; height: 100%;">-->
              <!--                <div>-->
              <!--                  <p class="small p-2 ms-3 mb-1 rounded-3" style="background-color: #f5f6f7;">Hi</p>-->
              <!--                  <p class="small p-2 ms-3 mb-1 rounded-3" style="background-color: #f5f6f7;">How are you ...???-->
              <!--                  </p>-->
              <!--                  <p class="small p-2 ms-3 mb-1 rounded-3" style="background-color: #f5f6f7;">What are you doing-->
              <!--                    tomorrow? Can we come up a bar?</p>-->
              <!--                  <p class="small ms-3 mb-3 rounded-3 text-muted">23:58</p>-->
              <!--                </div>-->
              <!--              </div>-->

              <!--              <div class="divider d-flex align-items-center mb-4">-->
              <!--                <p class="text-center mx-3 mb-0" style="color: #a2aab7;">Today</p>-->
              <!--              </div>-->
              <div v-for="(option, key) in list" :value="option._id" :key="key">
                <div class="d-flex flex-row justify-content-end mb-4 pt-1"
                     v-if="option.direction == 'inbound' && (option.message || option.template)">
                  <div>
                    <p class="small p-2 me-3 mb-1 text-white rounded-3 bg-info" v-if="option.message">{{
                        option.message
                      }}</p>
                    <p class="small p-2 me-3 mb-1 text-white rounded-3 bg-info" v-if="option.template">
                      {{ option.template }}</p>
                    <p class="small me-3 mb-3 rounded-3 text-muted d-flex justify-content-end">
                      {{ moment(option.timestamp).format('DD-MM-YYYY hh:mm:ss:SSS a') }}</p>
                  </div>
                  <img src="https://mdbcdn.b-cdn.net/img/Photos/new-templates/bootstrap-chat/ava4-bg.webp"
                       alt="avatar 1" style="width: 45px; height: 100%;">
                </div>

                <div class="d-flex flex-row justify-content-start mb-4"
                     v-if="option.direction == 'outbound' && (option.message || option.template)">
                  <img src="https://mdbcdn.b-cdn.net/img/Photos/new-templates/bootstrap-chat/ava3-bg.webp"
                       alt="avatar 1" style="width: 45px; height: 100%;">
                  <div>
                    <p class="small p-2 ms-3 mb-1 rounded-3" style="background-color: #f5f6f7;" v-if="option.message">
                      {{ option.message }} &nbsp;&nbsp;
                      <span style="color: #656668;float: right;" v-if="option.status == 'sent'">&#x2713;</span>
                      <span style="color: #656668;float: right;"
                            v-if="option.status == 'delivered'">&#x2713;&#x2713;</span>
                      <span style="color: #1178D8;font-weight: bold;float: right;" v-if="option.status == 'read'">&#x2713;&#x2713;</span>
                    </p>
                    <p class="small p-2 ms-3 mb-1 rounded-3" style="background-color: #f5f6f7;" v-if="option.template">
                      Template : {{ option.template }} &nbsp;&nbsp;
                      <span style="color: #656668;float: right;" v-if="option.status == 'sent'">&#x2713;</span>
                      <span style="color: #656668;float: right;"
                            v-if="option.status == 'delivered'">&#x2713;&#x2713;</span>
                      <span style="color: #1178D8;font-weight: bold;float: right;" v-if="option.status == 'read'">&#x2713;&#x2713;</span>
                    </p>
                    <p class="small ms-3 mb-3 rounded-3 text-muted">
                      {{ moment(option.timestamp).format('DD-MM-YYYY hh:mm:ss:SSS a') }}</p>
                  </div>
                </div>
              </div>
            </div>
            <div class="card-footer text-muted d-flex justify-content-start align-items-center p-3">
              <img src="https://mdbcdn.b-cdn.net/img/Photos/new-templates/bootstrap-chat/ava3-bg.webp"
                   alt="avatar 3" style="width: 40px; height: 100%;">
              <input type="text" class="form-control form-control-lg" id="exampleFormControlInput1"
                     placeholder="Type message">
              <a class="ms-1 text-muted" href="#!"><i class="fas fa-paperclip"></i></a>
              <a class="ms-3 text-muted" href="#!"><i class="fas fa-smile"></i></a>
              <a class="ms-3" href="#!"><i class="fas fa-paper-plane"></i></a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
// import { io } from "socket.io-client";
import {reactive} from "vue";
import moment from "moment/moment";

export const state = reactive({
  connected: false,
  fooEvents: [],
  barEvents: []
});

// "undefined" means the URL will be computed from the `window.location` object
// const URL = process.env.NODE_ENV === "production" ? undefined : "http://localhost:3012";
//
// export const socket = io(URL);
//
// socket.on("connect", () => {
//   state.connected = true;
// });
//
// socket.on("disconnect", () => {
//   state.connected = false;
// });
//
// socket.on("welcome", (...args) => {
//   state.fooEvents.push(args);
// });
//
// socket.on("bar", (...args) => {
//   state.barEvents.push(args);
// });
// socket.emit('welcome', { message: 'Welcome!', id: 0 });
// socket.on('welcome', function(data){
//   console.log(data);   //should output 'hello world'
// });
export default {
  components: {},
  data() {
    return {
      message: '',
      titleNumber: 'Chat',
      tables: [],
      list: [],
      phones: [],
      waId: '',
      integrated_number: "104128229238269"
    }
  },
  async created() {
    this.waId = this.$route.params.waId
    var getWaId = await this.getNumberIntegrationList();
    this.phones = getWaId.data.message;
    var getTemp = await this.getMessageLogs();
    this.tables = getTemp.data;
    if (this.tables.length) {
      this.titleNumber = this.tables[0]._id
      var getList = await this.getMessageList(0);
      this.list = getList.data;
    }
  },
  methods: {
    format_date(value) {
      if (value) {
        return moment(value).format('DD-MM-YYYY hh:mm:ss a')
      }
    },
    async getMessageLogs() {
      // const templateURL = 'https://graph.facebook.com/v16.0/100312339706932/message_templates?limit=3&access_token=EAAUJ4rpATrABAFJfj9AwJGKRzBX4l3VSNmfLZAlCcVChd8qGX8P6yv3djKZC8Kr9NEKhCagzqIbf8vTiuYt2xBPGjUr9prMuhOgYnvz2PDfcX5ioweo4RFwKOj884xG9beG0XmDPH1n1rmYd2zQJGfoHQQehlUj0gHxZCs1oNSZBEFQUos3qtqgOISZAthbLOC7PP1FRIawQmZC2ZCG3lzM7Xg7ZC41BTIsZD';
      const templateURL = '/whatsApp/message_web_group';
      return await this.axiosRequest(templateURL, {
        integrated_number: this.integrated_number,
        waId: this.waId
      });
    },
    async getMessageList(index) {
      const templateURL = '/whatsApp/message_web_list';
      return await this.axiosRequest(templateURL, {
        integrated_number: this.integrated_number,
        waId: this.waId,
        to: this.tables[index]['_id'],
        from: this.tables[index]['from'],
        direction: this.tables[index]['direction']
      });
    },
    async getOnLoadMessageLogs() {
      var getTemp = await this.getMessageLogs();
      this.tables = getTemp.data;
      if (this.tables.length) {
        var getList = await this.getMessageList(0);
        this.list = getList.data;
        this.titleNumber = this.tables[0]._id
      } else {
        this.titleNumber = "Chat"
      }
    },
    async getOnLoadMessageList(index) {
      if (this.tables.length) {
        this.titleNumber = this.tables[index]._id
        var getList = await this.getMessageList(index);
        this.list = getList.data;
      } else {
        this.titleNumber = "Chat"
      }
    },
    async getNumberIntegrationList() {
      // const templateURL = 'https://graph.facebook.com/v16.0/100312339706932/message_templates?limit=3&access_token=EAAUJ4rpATrABAFJfj9AwJGKRzBX4l3VSNmfLZAlCcVChd8qGX8P6yv3djKZC8Kr9NEKhCagzqIbf8vTiuYt2xBPGjUr9prMuhOgYnvz2PDfcX5ioweo4RFwKOj884xG9beG0XmDPH1n1rmYd2zQJGfoHQQehlUj0gHxZCs1oNSZBEFQUos3qtqgOISZAthbLOC7PP1FRIawQmZC2ZCG3lzM7Xg7ZC41BTIsZD';
      const templateURL = '/whatsApp/number_integration_list';
      return await this.axiosRequest(templateURL, {
        waId: this.waId
      });
    }
  }
}
</script>
<style>
.list-group, .scollHw {
  max-height: 100vh;
  overflow: auto;
}

::-webkit-scrollbar {
  width: 10px;
}

/* Track */
::-webkit-scrollbar-track {
  box-shadow: inset 0 0 5px grey;
  border-radius: 10px;
}

/* Handle */
::-webkit-scrollbar-thumb {
  background: gray;
  border-radius: 10px;
}

#chat2 .form-control {
  border-color: transparent;
}

#chat2 .form-control:focus {
  border-color: transparent;
  box-shadow: inset 0px 0px 0px 1px transparent;
}

.divider:after,
.divider:before {
  content: "";
  flex: 1;
  height: 1px;
  background: #eee;
}
</style>
